import { Nullable } from '@sp/util/helpers';
import { UploadedFile } from './space-types/concrete-space.types';

export type ExpertSlug = string;
export type UserID = number;

export type UserLink = {
  href: string;
  title: string;
  order: number;
};

export type MeUserLink = {
  href: string;
  title: string;
  id: number;
  order: number;
  createdAt: number;
  updatedAt?: Nullable<number>;
};

export enum NotificationLevel {
  high = 'high',
  low = 'low',
  off = 'off',
}

export type NotificationSettings = {
  newMessagesInChallenges: boolean; // вообще все сообщения в челленджах
  newMentionsInChallenges: boolean; // упоминания в челленджах
  newCreatorsMessagesInChallenges: boolean; // сообщения криейтора в челленджах
  newMessagesInDMs: boolean; // новые сообщения в DM
  newPlatformMessages: boolean; // новые сообщения в канале платформы
  newRepliesInChallenges: boolean; // новые реплаи в челленджах
};

// MeUser
// PublicUser
// Member

export type KnownCardBrand =
  | 'visa'
  | 'mastercard'
  | 'amex'
  | 'discover'
  | 'jcb'
  | 'diners'
  | 'unionpay'
  | 'cartes_bancaires';

export interface MeUser {
  id: UserID;
  created_at: number;
  name: string;
  email: string | null;
  isAdmin: boolean;
  isExpert: boolean;
  description: string | null;
  bio: string | null;
  isFirstChallengeVisited: boolean;
  isRegistrationCompleted: boolean; // TODO[Dmitriy Teplov] ?
  slug: string; // TODO[Dmitriy Teplov] нужен обычным юзерам?
  subscriptionPrice: number | null;
  notifications: NotificationSettings;
  avatar: {
    url: string | null;
  } | null;
  pinnedChatsIds: number[] | null;
  paymentMethod: {
    id: string;
    card: {
      brand: KnownCardBrand;
      last4: string;
      exp_month: number;
      exp_year: number;
    };
  } | null;
  archivedChatsIds: number[] | null;
}

export interface UserAvatar {
  readonly url: string | null;
}

export type Skill = {
  readonly points: number;
  readonly tag: {
    readonly id: number;
    readonly name: string;
    readonly color: string;
  } | null;
};

export interface PublicUser {
  id: UserID;
  name: string;
  bio: string | null;
  created_at: number;
  isExpert: boolean; // FIXME[Dmitriy Teplov] change to isExpert: false
  // slug: string; // TODO[Dmitriy Teplov] нужен обычным юзерам?
  links: UserLink[];
  avatar: UserAvatar | null;
  points: readonly Skill[];
}

export type CreatorCommunity = Readonly<{
  id: number; // space id
  title: string;
  cover: UploadedFile | null;
  description: string | null;
  subscribersCount: number;
  price: number;
  iosProductId: string | null;
  trialPrice: number;
  subscription: null | Readonly<{ isActive: boolean }>;
  marketingPriceConfig: Readonly<{
    iosPrice: number;
    iosTrialPrice: number;
  }>;
}>;

export type ExpertUser = Omit<PublicUser, 'isExpert'> & {
  isExpert: true;
  slug: string;
  description: string;
  subscriptionPrice: number;
  communities: readonly CreatorCommunity[];
};

export function isExpertUser(user: PublicUser | ExpertUser): user is ExpertUser {
  return user.isExpert;
}

export type UserCreator = {
  id: number;
  name: string;
  avatar: Nullable<{ url: Nullable<string> }>;
};

export type UserCreators = {
  subscriptions: UserCreator[];
  purchases: UserCreator[];
};
